<div class="call-reserve-card">
  <!-- Header con título y toggle -->
  <div class="card-header">
    <div class="title-container">
      <h3 class="card-title">Reservar servicio</h3>
    </div>
    <ion-toggle [checked]="isReserveExpanded" (ionChange)="onToggleReserve($event)" class="reserve-toggle">
    </ion-toggle>
  </div>

  <!-- Calendario y selector de hora (visible cuando está expandido) -->
  <div class="calendar-container" *ngIf="isReserveExpanded">
    <!-- Calendario -->
    <ion-datetime presentation="date" [value]="selectedDate" [min]="minDate" (ionChange)="onDateChange($event)"
      class="custom-calendar">
    </ion-datetime>

    <!-- Selector de hora -->
    <div class="time-selector">
      <div class="time-label">Hora* (formato 24h)</div>
      <div class="time-input-wrapper">
        <div class="time-display-container" [class.valid]="isTimeValid()"
          [class.invalid]="timeInput.length === 4 && !isTimeValid()">
          <span class="time-display">{{ displayTime }}</span>
        </div>
        <input type="text" class="time-mask-input" [value]="timeInput" (input)="onTimeInput($event)"
          placeholder="Ej: 1130 = 11:30" maxlength="4">
      </div>
      <div class="time-hint" *ngIf="timeInput.length > 0 && !isTimeValid()">
        <span class="hint-text">Formato inválido. Use HHMM (00:00 - 23:59). Ej: 0930, 1430, 2159</span>
      </div>
    </div>
  </div>
</div>